import { FpsView } from 'react-fps';

import { isDev } from 'lib/env';

export const FPSAnalysis = () => (isDev ? <FpsView /> : null);

export default FPSAnalysis;
